import React from 'react';
import { Box, Typography } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts';

// Arc colour by charge level, matching the old gauge's bands (red <= 10 %, amber <= 25 %)
const socColor = (soc) => {
  if (soc <= 10) return "#EF4444";
  if (soc <= 25) return "#F59E0B";
  return "var(--c-brand)";
};

const SocGauge = ({
  soc,
  statusText,
}) => {
  const hasSoc = soc !== null && soc !== undefined;

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1.5,
    }}>
      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "var(--c-text-muted)" }}>
        State of charge
      </Typography>

      <Box sx={{ position: "relative", width: 200, height: 110 }}>
        <Gauge
          cornerRadius="50%"
          value={hasSoc ? soc : 0}
          startAngle={-90}
          endAngle={90}
          innerRadius="82%"
          outerRadius="100%"
          margin={0}
          width={200}
          height={110}
          sx={{
            [`& .${gaugeClasses.valueText}`]: { display: "none" },
            [`& .${gaugeClasses.valueArc}`]: { fill: hasSoc ? socColor(soc) : "var(--c-brand)" },
            [`& .${gaugeClasses.referenceArc}`]: { fill: "var(--c-border)" },
          }}
        />

        {/* Centered value */}
        <Box sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "baseline",
        }}>
          <Typography sx={{
            fontSize: 40,
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: "-0.02em",
            fontVariantNumeric: "tabular-nums",
            color: hasSoc ? "var(--c-text)" : "var(--c-border-strong)",
          }}>
            {hasSoc ? Number(soc).toFixed(0) : "–"}
          </Typography>
          {hasSoc && (
            <Typography sx={{ fontSize: 18, fontWeight: 500, color: "var(--c-text-muted)", ml: 0.25 }}>
              %
            </Typography>
          )}
        </Box>
      </Box>

      {statusText && (
        <Typography sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "var(--c-text-3)",
          backgroundColor: "var(--c-muted)",
          borderRadius: "999px",
          px: 1.25,
          py: 0.25,
          lineHeight: 1.5,
          whiteSpace: "nowrap",
        }}>
          {statusText}
        </Typography>
      )}
    </Box>
  )
}

export default SocGauge;
